import React from "react";
import { createPortal } from "react-dom";

export default function Modal({
  open,
  title,
  children,
  onClose,
  footer,
  scroll = true,
  panelClassName = "max-w-3xl w-[92vw] md:w-[800px]",
}) {
  if (!open) return null;

  const content = (
    <div className="fixed inset-0 z-[100]">
      <div className="absolute inset-0 bg-black/70" onClick={onClose} />
      <div className="absolute inset-0 overflow-y-auto">
        <div className="min-h-full w-full flex items-start justify-center p-4 md:p-6">
          <div className={`relative card rounded-2xl ${panelClassName} p-6 z-[101]`}>
            <button className="absolute top-3 right-3 btn btn-ghost" onClick={onClose}>
              &times;
            </button>
            {title && <h3 className="text-lg font-bold mb-3">{title}</h3>}
            <div className={scroll ? "max-h-[70vh] overflow-auto" : ""}>{children}</div>
            {footer && <div className="mt-4 flex justify-end gap-2">{footer}</div>}
          </div>
        </div>
      </div>
    </div>
  );

  if (typeof document === "undefined") return content;
  return createPortal(content, document.body);
}
